import React from 'react';
import { Skeleton, TableCell, TableRow } from '@mui/material';

// Skeleton rows used while a table is loading.
const TableSkeleton = ({ rows = 6, columns = 5, size = 'medium' }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <TableRow key={r}>
        {Array.from({ length: columns }).map((__, c) => (
          <TableCell key={c} size={size}>
            <Skeleton
              variant="text"
              width={c === 0 ? '60%' : `${40 + ((r + c) % 3) * 15}%`}
              height={18}
            />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export default TableSkeleton;
